import { createActionTypes } from '../../util/createActionTypes';

export default createActionTypes(['DIALOG_TOGGLE']);
